import React from 'react';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'


const InputPhoneNumber = ({
    label,
    name,
    id,
    value = '',
    required,
    rightIcon,
    rightIconAction,
    onBlur,
    onFocus,
    onChange = () => { },
    error,
    helperText,
    size = 'medium', // small, medium, large
    inputProps,
    ...props
}) => {
   

   

    const handleOnChange = (value, data) => {
        let countryCode = null, mobile = null
        if ((value?.length || 0) > (data?.dialCode?.length || 0)) {
            countryCode = data?.dialCode
            const codeLength = data?.dialCode?.length;
            mobile = value.slice(codeLength);
        } else {
            countryCode = value
        }
        onChange({ country_code: countryCode, number: mobile, name })
    };

    return (
        <div >
            <label htmlFor={id || name}
                style={{
                    fontSize: '11px',
                    fontWeight: '500'
                }}
            >  {label} </label>
            <PhoneInput
                inputProps={{
                    name,
                    id,
                    required,
                    ...inputProps
                }}
                value={value}
                onChange={handleOnChange}
                {...props}
            />



        </div>
    );
}

export default InputPhoneNumber